<template>
  <b-container class="form-actions">
    <b-row>
      <LoadingButton
        :loading="loading"
        :text="Lưu"
        @click="$emit('save')"
      />

      <b-button
        variant="secondary"
        size="sm"
        style="margin-left: 10px; font-weight: 600; width: 70px"
        @click="handleCancel"
      >
        Hủy
      </b-button>
      <b-col></b-col>
      <b-col></b-col>
      <b-col></b-col>
    </b-row>
  </b-container>
</template>

<script>
import LoadingButton from './LoadingButton.vue';
export default {
  name: 'FormActions',
  components: {
    LoadingButton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    cancelRoute: {
      type: [Object, String],
      default: () => null,
    },
    cancelText: {
      type: String,
      default: 'Hủy',
    },
    saveText: {
      type: String,
      default: 'Lưu',
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
      if (this.cancelRoute) {
        this.$router.push(this.cancelRoute);
      }
    },
  },
};
</script>

<style scoped>
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.2em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style> 
